import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import mixpanel from 'mixpanel-browser';
import isInternalReferral from './lib/internal-referral';
import initSentry from './lib/sentry';
import createChunkErrorHandler, { lazySessionStorage } from './lib/reload-on-chunk-error';

declare global {
  interface Window {
    dataLayer: any[]
  }
}

initSentry({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_STAGE,
});

// docs.geolonia.com からの内部の遷移では、施策の初回接触（initial_utm_*）を
// 記録しない。記録すると、gmail や x.com の施策で来た人の初回接触が
// docs.geolonia.com に置き換わってしまう。イベントのプロパティに載るほうの
// utm_* は変わらないので、流入元別の集計はこれまでどおりできる。
const mixpanelConfig = { skip_first_touch_marketing: isInternalReferral() };

if (process.env.REACT_APP_MIXPANEL_TOKEN) {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN as string, mixpanelConfig);
} else {
  mixpanel.init('test', { ...mixpanelConfig, debug: true });
}

window.addEventListener('vite:preloadError', createChunkErrorHandler({
  storage: lazySessionStorage(),
  reload: () => window.location.reload(),
  now: Date.now,
}));

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
